export { default } from './appendOwnerState';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/appendOwnerState/index.js
// module id = 380
// module chunks = 22